/* global axios */
import ApiClient from '../ApiClient';

class ContactInboxThreadApi extends ApiClient {
  constructor() {
    super('contact_inboxes', { accountScoped: true });
  }

  getMessages({ contactInboxId, after, before }) {
    const params = {};
    if (before) params.before = before;
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${contactInboxId}/messages`, { params });
  }
}

export default new ContactInboxThreadApi();
